import { ITicketMessage, ITicket } from '@nkr/models/index';
import { MessageType, TicketVisibility } from '@nkr/enums/index';
import { Panel, Glyphicon, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';

interface IPanelWrapperProps {
    background?: string
}

const PanelWrapper = styled(Panel) <IPanelWrapperProps>`
    & > div.panel-heading {
        background-color: ${p => p.background ? p.background : 'initial'}
    }

    & > div.panel-body {
        background-color: ${p => p.background ? p.background : 'initial'}
    }

    & > div.panel-footer {
        background-color: ${p => p.background ? p.background : 'initial'}
    }
`;

interface IProps {
    ticket: ITicket,
    ticketMessage: ITicketMessage,
    isCenter: boolean,
}

const Message = (props: IProps) => {
    const getBackground = () => {
        if (props.ticketMessage.from != null) {
            if (props.ticketMessage.from.email != 'tickets@kidneyregistry.org')
                return '#FCF0E1';

            if (props.ticketMessage.from.email == 'tickets@kidneyregistry.org')
                return '#E5F1FD';
        }

        return '';
    };

    const { from, fromEmail, to, createdDateTime, subject, message } = props.ticketMessage;
    const fullName = from != null ? from.fullName : '';

    return (
        <>
            <PanelWrapper background={getBackground()} style={{ marginTop: !props.isCenter ? 15 : 0 }} defaultExpanded={false}>
                <Panel.Heading
                    className={props.ticketMessage.type == MessageType.Note ? ' bg-warning' : ' bg-info'}
                    style={{ marginTop: 0, marginBottom: 0, padding: '5px 7.5px' }}
                >
                    <Panel.Toggle>
                        {props.ticketMessage.type == MessageType.FirstContact && props.ticket.isEmail == false && (
                            <>
                                <div><strong>{fullName}</strong> submitted on {createdDateTime}</div>

                                {props.ticketMessage.cc.length > 0 && (
                                    <div>CC: {props.ticketMessage.cc.map(x => x.email).join(', ')}</div>
                                )}

                                {props.ticketMessage.bcc.length > 0 && (
                                    <div>BCC: {props.ticketMessage.bcc.map(x => x.email).join(', ')}</div>
                                )}
                            </>
                        )}

                        {props.ticketMessage.type == MessageType.FirstContact && props.ticket.isEmail == true && (
                            <>
                                <div><strong>{fromEmail}</strong> submitted on {createdDateTime}</div>

                                {props.ticketMessage.cc.length > 0 && (
                                    <div>CC: {props.ticketMessage.cc.map(x => x.email).join(', ')}</div>
                                )}

                                {props.ticketMessage.bcc.length > 0 && (
                                    <div>BCC: {props.ticketMessage.bcc.map(x => x.email).join(', ')}</div>
                                )}
                            </>
                        )}

                        {props.ticketMessage.type == MessageType.Note && (
                            <>
                                <div><strong>{from != undefined ? from.fullName : ''}</strong> posted on {createdDateTime}</div>
                            </>
                        )}

                        {props.ticketMessage.type == MessageType.Reply && (
                            <>
                                <div><strong>{from.fullName}</strong> replied on {createdDateTime}</div>

                                {props.ticketMessage.cc.length > 0 && (
                                    <div>CC: {props.ticketMessage.cc.map(x => x.email).join(', ')}</div>
                                )}

                                {props.ticketMessage.bcc.length > 0 && (
                                    <div>BCC: {props.ticketMessage.bcc.map(x => x.email).join(', ')}</div>
                                )}
                            </>
                        )}

                        {props.ticketMessage.type == MessageType.Forward && (
                            <>
                                <div><strong>{from.fullName}</strong> forwarded to {to.map(x => x.email).join(',')} on {createdDateTime}</div>

                                {props.ticketMessage.cc.length > 0 && (
                                    <div>CC: {props.ticketMessage.cc.map(x => x.email).join(', ')}</div>
                                )}

                                {props.ticketMessage.bcc.length > 0 && (
                                    <div>BCC: {props.ticketMessage.bcc.map(x => x.email).join(', ')}</div>
                                )}
                            </>
                        )}

                        <div>{subject}</div>
                    </Panel.Toggle>
                </Panel.Heading>

                <Panel.Collapse>
                    <Panel.Body>
                        <div style={{ width: '100%', minHeight: 200, overflowX: 'auto' }}>
                            {/* {parse(message)} */}
                            <div dangerouslySetInnerHTML={{__html: message}} />
                            {props.ticketMessage.files.length > 0 && (
                                <div style={{ padding: 10 }}>
                                    {props.ticketMessage.files.map((file, index) =>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ marginRight: 5 }}><a href={`${__API__}/ticketing/ticket/${props.ticket.id}/message/${props.ticketMessage.id}/file/${file.fileIndex}`} target='_blank'>{file.fileName}</a></div>
                                            <OverlayTrigger placement='top' overlay={<Tooltip>Download</Tooltip>}>
                                                <a href={`${__API__}/ticketing/ticket/${props.ticket.id}/message/${props.ticketMessage.id}/file/${file.fileIndex}`} className='btn btn-link' style={{ paddingRight: 0 }} target='_blank'><Glyphicon glyph='download-alt' /></a>
                                            </OverlayTrigger>

                                            <OverlayTrigger placement='top' overlay={<Tooltip>Remove</Tooltip>}>
                                                <Button bsStyle='link'><Glyphicon glyph='trash' /></Button>
                                            </OverlayTrigger>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </Panel.Body>
                </Panel.Collapse>

                {props.ticketMessage.type == MessageType.Note && (
                    <Panel.Footer style={{ display: 'flex', justifyContent: 'flex-end', padding: '5px 7.5px' }}>
                        <div>Visible to {props.ticketMessage.visibility == TicketVisibility.Nkr ? 'NKR' : TicketVisibility[props.ticketMessage.visibility]}</div>
                    </Panel.Footer>
                )}
            </PanelWrapper>
        </>
    );
}

export default Message;